import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { Trash2, Edit } from 'lucide-react';
import { callApi } from '../services/ApiServices';
import ConfirmationModal from '../components/common/ConfirmationModal';
import AddStaffModal from '../components/common/AddStaffModal';
import ChangePasswordModal from '../components/common/ChangePasswordModal';
import toast from 'react-hot-toast';
import { ImagePath } from '../components/common/ImagePath';
import CommonPagination from '../components/common/CommonPagination';
import CommonLoader from '../components/common/CommonLoader';
import { useGlobalStates } from '../utlis/ClubsContext';
import { UserRole } from '../utlis/constant';

const StaffManagement = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [openStaffModal, setOpenStaffModal] = useState(false);
    const [changePasswordModal, setChangePasswordModal]= useState(false)
    const [openStaffEditModal, setOpenStaffEditModal] = useState(false);
    const [selectedStaffForEdit, setSelectedStaffForEdit] = useState(null)
    const {userRole}= useGlobalStates()
    const [staffData, setStaffData] = useState([]);
    const [staffId, setStaffId] = useState(null)
    const limit = 10


    useEffect(() => {
      fetchStaffListing(currentPage, limit, searchQuery);
    }, []);
  
    const fetchStaffListing = async (page, limit, search) => {
      let ApiUrl = `admin/staff?page=${page}&limit=${limit}`; 
      if (search) {
        ApiUrl += `&search=${search}`
      }
      if(!search){
        setLoading(true);
        
      }
      try {
        const response = await callApi({
          method: "get",
          url: ApiUrl,
        });
        console.log("staff Listing", response);


      const totalItems = response?.pagination?.total;
      const totalPages = Math.ceil(totalItems/limit)
      setTotalCount(totalPages)
        setStaffData(response?.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching contact us listing:", error);
        setLoading(false);
      }
    };
  const handleDelete = (id) => {
    setOpenConfirmationModal(true)
    setSelectedStaff(id)
  };

  const onClickDelete =  async()=>{
    try {
      setLoading(true)
      const response = await callApi({
        method:"delete",
        url:`admin/staff/${selectedStaff}`,
        data:{}
      })
      if(response.status==200){
        toast.success(response?.message || "staff deleted successfully" )
        setOpenConfirmationModal(false)
        fetchStaffListing(currentPage, limit, searchQuery)
      }
      console.log("delete response", response)
    } catch (error) {
      console.log("error while delete staff", error)
    }finally{
      setLoading(false)
    }
  }

    const onSaveStaff = async (formData)=>{
      console.log("onsave formData", formData)
    try {
      setLoading(true)
      const response = await callApi({
        method:"post",
        url:`admin/staff`,
        data:{
          name:formData.name,
          email:formData.emailid,
          access:formData.access,
          password:formData.password
        }
      })
      console.log("created staff", response)
      if(response.status==201){
        toast.success(response?.data?.message || "staff created successfully" )
        setOpenStaffModal(false)
        fetchStaffListing(currentPage,limit,searchQuery)
      }
    } catch (error) {
      console.log("error while delete staff", error)
    }finally{
      setLoading(false)
    }
  }

      const onEditStaff = async (formData)=>{
    try {
      setLoading(true)
      const response = await callApi({
        method:"post",
        url:`admin/update/access/${selectedStaffForEdit?.id}`,
        data:{
          name:formData.name,
          access:formData.access
       
        }
      })
      console.log("Edit staff", response)
      if(response.status==201){
        toast.success(response?.data?.message || "staff Edit successfully" )
        setOpenStaffEditModal(false)
        fetchStaffListing(currentPage,limit,searchQuery)
      }
    } catch (error) {
      console.log("error while delete staff", error)
    }finally{
      setLoading(false)
    }
  }




  const handleChangePassword = async(formData) => {
   
    try{
      const response = await callApi({
        method:"post",
        url:`admin/change/password/${staffId}`,
        data:{
          // currentPassword:formData.currentPassword,
          newPassword:formData.newPassword
        }
      })
      console.log("change password", response)
      if(response.status=== 201){
        toast.success(response?.message || "password changed successfully" )
        return true
      }
      return false

    }catch(error){
      console.log("error while changing password", error)
      return false}

  };

  const toggleStatus = async (status, staffId)=>{
    const newStatus = status === "active" ? "inactive" : "active"
    try{
      const res = await callApi({
        method:"patch",
        url: `admin/status?userId=${staffId}`,
        data:{
          status:newStatus
        }
      })
      if(res.status == 200){
        toast.success(res?.message || "staff status changed successfully",{id:"staffStatusToast"})
        fetchStaffListing(currentPage,limit,searchQuery)
      }
      console.log("toggle status", res)
    }catch(error){
      console.log("error while toggling status", error)
    }
  }

    const OnPageChange = (e) => {
    setCurrentPage(e);
    fetchStaffListing(e, limit, searchQuery);
  };

  return (
    <>
      {/* Search Bar */}
      {loading && <CommonLoader fullScreen />}
      <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6"'>
        <div className="mb-6 relative w-full sm:flex-1 sm:max-w-[320px]">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="search"
            name="search"
            placeholder="Search by Name and email..."
            value={searchQuery}
            autoComplete="off"
            autoCapitalize="off"
            spellCheck={false}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
              fetchStaffListing(1, 10, e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === " " && searchQuery?.length === 0) {
                e.preventDefault();
              }
            }}
            className="w-full pl-12 pr-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-base text-black placeholder-textcolor"
          />
        </div>
        <button
          onClick={() => setOpenStaffModal(true)}
          className="w-full sm:w-auto flex items-center justify-center gap-2 bg-primary hover:bg-hover text-white font-medium text-base px-6 py-3 rounded-lg transition-colors"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 4V16M4 10H16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Add Staff
        </button>
      </div>
      {/* Table Container */}
      <div className="bg-white rounded-[12px] shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            {/* Table Header */}
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Name
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Email ID
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Access
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Status
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Action
                </th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {staffData?.length > 0 ? (
                staffData?.map((staff, index) => (
                  <tr
                    key={staff.id}
                    className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                      index === staffData.length - 1 ? "border-b-0" : ""
                    }`}
                  >
                    {/* Name */}
                    <td className="px-6 py-4">
                      <span className="text-sm text-textcolor">
                        {staff?.name || "-"}
                      </span>
                    </td>

                    {/* Email ID */}
                    <td className="px-6 py-4">
                      <span className="text-sm text-textcolor">
                        {staff?.email || "-"}
                      </span>
                    </td>

                    {/* Access */}
                    <td className="px-6 py-4">
                      <span className="text-sm text-textcolor">
                        {staff?.access_permission
                          ? staff?.access_permission.charAt(0).toUpperCase() +
                            staff?.access_permission.slice(1)
                          : "-"}
                      </span>
                    </td>

                    {/* status */}
                    <td className="px-6 py-4">
                      <button
                        type="button"
                        disabled={userRole === UserRole.Viewer}
                        onClick={() => toggleStatus(staff?.status, staff.id)}
                        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-300 focus:outline-none 
                            ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
                            ${staff?.status === "active" ? "bg-[#4CAF50]" : "bg-gray-300"}
                          `}
                      >
                        <span
                          className={`inline-block h-3.5 w-3.5 rounded-full bg-white transform transition-transform duration-300
                             ${staff?.status === "active" ? "translate-x-5" : "translate-x-1"}
                          `}
                        />
                      </button>
                    </td>

                    {/* Action Buttons */}
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        {/* Delete Button */}
                        <button
                          onClick={() => handleDelete(staff.id)}
                          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-white border border-red-200 rounded-lg hover:bg-red-50 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                        >
                          <Trash2 className="w-4 h-4" />
                          Delete
                        </button>

                        {/* Change Password Button */}
                        <button
                          onClick={() => {
                            setChangePasswordModal(true);
                            setStaffId(staff.id);
                          }}
                          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                          <Edit className="w-4 h-4" />
                          Change Password
                        </button>
                        <button
                          onClick={() => {
                            setOpenStaffEditModal(true);
                            setSelectedStaffForEdit(staff);
                          }}
                          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                          {/* <Edit className="w-4 h-4" />
                           */}
                          <img
                            src={ImagePath.UpdateStaff}
                            alt="Update Staff"
                            style={{ width: 20, height: 20 }}
                          />
                          Update staff
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="px-6 py-10 text-center">
                    <div className="flex justify-center items-center">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2">No Data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <ConfirmationModal
          isOpen={openConfirmationModal}
          onConfirm={onClickDelete}
          onCancel={() => setOpenConfirmationModal(false)}
        />
        {openStaffModal && (
          <AddStaffModal
            title="Add staff"
            description="Add a new staff member to the system."
            onClose={() => setOpenStaffModal(false)}
            onSave={onSaveStaff}
            isLoading={loading}
            type="AddStaff"
          />
        )}
        {openStaffEditModal && (
          <AddStaffModal
            title="Update staff"
            onClose={() => setOpenStaffEditModal(false)}
            description="Edit-team member information and adjust their platform access level."
            onSave={onEditStaff}
            isLoading={loading}
            initialValues={{
              name: selectedStaffForEdit?.name || "",
              emailid: selectedStaffForEdit?.emailid || "",
              access: selectedStaffForEdit?.access_permission || "",
            }}
          />
        )}

        {changePasswordModal && (
          <ChangePasswordModal
            onClose={() => setChangePasswordModal(false)}
            onSave={handleChangePassword}
          />
        )}
      </div>
      <CommonPagination
        currentPage={currentPage}
        pageCount={totalCount}
        onPageChange={(e) => OnPageChange(e)}
      />
    </>
  );
};

export default StaffManagement;
